import React from 'react';
import SamplingBox from './SamplingBox';
import SignalsBox from './SignalsBox';
import HeatmapWorkerParameters from './HeatmapWorkerParameters';
import CollapseableBox from './CollapseableBox';

const CollapseableWorkerParameters = CollapseableBox(HeatmapWorkerParameters);
const CollapseableSamplingBox = CollapseableBox(SamplingBox);
const CollapseableSignalsBox = CollapseableBox(SignalsBox);

const HeatMapParameters = props => {
  return [
    <CollapseableSamplingBox rank={1} title="Sampling (WHO)" key="sampling" />,
    <CollapseableWorkerParameters rank={2} title="Heatmap parameters" key="workerParameters" />,
    <CollapseableSignalsBox rank={3} title="Signals" key="signals" />
  ];
};

export default HeatMapParameters;



// WEBPACK FOOTER //
// ./src/scenes/analysis/components/analysis/parameters/HeatMapParameters.js